// extracted by mini-css-extract-plugin
export default {"wrapper":"TitleAndDesc_wrapper__2kq9q","title":"TitleAndDesc_title__1jpcC","description":"TitleAndDesc_description__gieb2"};